import React from 'react'
import hasValue from './has_value'

export default class CheckboxInput extends React.Component {
  isCheckedFromProps = () => {
    const { value, fieldAnswer } = this.props.element
    return hasValue(fieldAnswer) && String(value) === String(fieldAnswer)
  }

  state = { checked: this.isCheckedFromProps() }

  onChange = (e) => {
    this.setState({ checked: e.target.checked })
  }

  render () {
    const { element, path, mode } = this.props
    const { label, value, id } = element

    const inputId = `chk-${id || path.slice(-1)}`

    return (
      <div className="form-check">
        <input type="hidden" name="fields_answers_attributes[][value]" value={this.state.checked ? value : ''} />
        <input type="checkbox" id={inputId}
          className="form-check-input" value={value}
          disabled={mode.isReadOnly()}
          checked={this.state.checked}
          onChange={this.onChange}
        />
        <input type="hidden" name="fields_answers_attributes[][field_id]" value={id} />
        { label && <label htmlFor={inputId} className="form-check-label">{label}</label> }
      </div>
    )
  }
}
